import React from "react";
import { useDispatch } from "react-redux";
import { startGetAsistencias, startGetAsistenciasXls } from "../../context/actions/asistenciasActions";

export const useForma = () => {
  const dispatch = useDispatch();
  const [body, setBody] = React.useState({});
  const handleChange = (dates, dateStrings) => {
    if (dates && dates[0] && dates[1]) {
      setBody({
        fechaInicio: dates[0].toISOString(),
        fechaFin: dates[1].toISOString()
      });
    } else {
      setBody({});
    }
  };

  const isDisabled =
    Object.keys(body).length === 0 || !body.fechaInicio || !body.fechaFin;

  const submit = () => dispatch(startGetAsistenciasXls(body));

  const handleFilter = () => dispatch(startGetAsistencias(body.fechaInicio, body.fechaFin));

  return { handleChange, isDisabled, submit, handleFilter };
};
